import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Grid,
  Box,
  FormGroup,
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import { CanvasRead, ValueCanvasRead } from '../../CreateIdeaDialogs';
import { IdeaApproverTable, IdeaEngagement } from '../..';
import { MenuInformation } from '../../Shared';
import { ideaActions } from '../../../actions';
import { IdeaCss } from '../IdeaCss';
import { useIdeaDetailsController } from '../../../containers/IdeaDetailsPage/hooks/useIdeaDetailsController';
import {IdeaInfo} from './IdeaInfo';
import {IdeaDetails} from './IdeaDetails';
import {IdeaVote} from './IdeaVote';
import {IdeaCategory} from './IdeaCategory';
import {IdeaCanvas} from './IdeaCanvas';
import {IdeaContributors} from './IdeaContributors';
import {IdeaFinancialReturn} from './IdeaFinancialReturn';
import {IdeaAttachments} from './IdeaAttachments';
import {IdeaBusinessUnitLocal} from './IdeaBusinessUnitLocal';

export function IdeaGeneral() {
  const classes = IdeaCss();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isOpenCanvas, setIsOpenCanvas] = useState(false);
  const [isOpenValueCanvas, setIsOpenValueCanvas] = useState(false);
  const user = useSelector(state => state.user);
  const {defaultCategories} = useSelector(state => state.fluxIdeas);
  const { hasIdeaFlux, stepflux, ideaDetailsFlux } = useIdeaDetailsController();
  const [highlight, setHighlight] = useState(hasIdeaFlux?.highlight);

  function handleOnOpenValueCanvas() {
    setIsOpenValueCanvas(true)
  }

  function handleOnCloseValueCanvas() {
    setIsOpenValueCanvas(false)
  }

  function handleOnOpenCanvas() {
    setIsOpenCanvas(true)
  }

  function handleOnCloseCanvas() {
    setIsOpenCanvas(false)
  }

  function handleChange() {
    dispatch(ideaActions.sendTimelineView(hasIdeaFlux._id, setHighlight));
  }

  function isFillCanvas(canvas) {
    if (!!canvas.length) {
      const hasAnswer = canvas.map((item) => item.answer?.length).some((length) => length > 0);
      return hasAnswer;
    };
    return false
  };

  return (
    <>
      <CanvasRead idea={hasIdeaFlux} isOpen={isOpenCanvas} onClose={handleOnCloseCanvas} />
      <ValueCanvasRead idea={hasIdeaFlux} isOpen={isOpenValueCanvas} onClose={handleOnCloseValueCanvas} />

      <Grid container spacing={2}>
        <IdeaInfo />

        <Grid item xs={12} sm={4} md={4} lg={4}>
          <Grid container spacing={2}>
            <IdeaDetails />

            {user._id !== hasIdeaFlux?.user?._id && <IdeaVote />}

            {(isFillCanvas(hasIdeaFlux.canvas) || isFillCanvas(hasIdeaFlux.canvasValueProposition)) && (
              <IdeaCanvas
                handleOnOpenValueCanvas={handleOnOpenValueCanvas}
                handleOnOpenCanvas={handleOnOpenCanvas}
              />
            )}

            {hasIdeaFlux.contributors?.length > 0 && <IdeaContributors />}
          </Grid>
        </Grid>
        
        {user.typeProfile.type === 'admin' && defaultCategories.length >= 0 && <IdeaCategory />}
        
        {stepflux && (hasIdeaFlux?.estimatedExecutionCost > 0 || hasIdeaFlux?.estimatedFinancialReturn > 0) && <IdeaFinancialReturn />}

        {(hasIdeaFlux.links?.length > 0 || hasIdeaFlux.attachments?.length > 0) && <IdeaAttachments />}

        {(hasIdeaFlux?.businessUnitLocal?.map(item => item)[0]) && <IdeaBusinessUnitLocal />}

        {hasIdeaFlux?.currentStepFlux?.evaluatorsInStep?.length > 0 && (
          <>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center">
                <Typography className={classes.titleUpperCase}>
                  {t('qualificadores_atribuidos')}
                </Typography>
                <MenuInformation>
                  {t('possiveis_qualificadores_para_essa_ideia_sao_os_gestores_da_area_de_abrangencia_vinculada')}
                </MenuInformation>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <IdeaApproverTable />
            </Grid>
          </>
        )}

        {(user.typeProfile.type === ('admin' || 'manager')) && (
          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                label={t('exibir_ideia_no_feed')}
                control={
                  <Switch
                    color="primary"
                    checked={highlight}
                    onChange={handleChange}
                  />
                }
              />
            </FormGroup>
          </Grid>
        )}
      </Grid>

      {hasIdeaFlux?.statusIdea?.code !== 'DRAFT' && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <IdeaEngagement id={ideaDetailsFlux._id} />
          </Grid>
        </Grid>
      )}
    </>
  );
}